import * as React from 'react';
import { namespacedClassnames } from '../../common';
var defaultSize = {
    w: 20,
    h: 15
};
var calcPos = function (letter, size) {
    return -(letter.toLowerCase().charCodeAt(0) - 97) * size;
};
export var CountryFlag = function (props) {
    if (!props.countryCode || props.countryCode.length < 2) {
        return React.createElement("i", null, "N/A");
    }
    var x = calcPos(props.countryCode[1], defaultSize.w);
    var y = calcPos(props.countryCode[0], defaultSize.h);
    var style = {
        backgroundPosition: x + "px " + y + "px",
    };
    var maybeName = !!props.name ? (React.createElement("span", { className: 'country-name' }, props.name)) : null;
    return (React.createElement("span", { className: namespacedClassnames('country-flag-container') },
        React.createElement("span", { className: "flag-icon " + props.countryCode, "data-country": props.countryCode, style: style }),
        maybeName));
};
//# sourceMappingURL=country-flag.js.map